import React from "react";
import { RenderWhen } from "../../../../../components";
import { Title } from "../../../../../components/dynamicanalysis";
import { DroppedFilesGridData } from "../../../@types/rldynamicanalysis";
import { DYNAMIC_ANALYSIS_EMPTY_MESSAGES } from "../consts";
import DownloadDroppedFilesButton from "./DownloadDroppedFilesButton";
import DroppedFilesStaticAnalysisButton from "./DroppedFilesStaticAnalysisButton";
import RlCloudSandboxDroppedFilesGrid from "./RlCloudSandboxDroppedFilesGrid";

type RlCloudSandboxDroppedFilesProps = {
  analysisId: string;
  droppedFiles: Array<DroppedFilesGridData>;
  isMergedReport: boolean;
  isStoredReport: boolean;
  isPrivate: boolean;
  isNetworkReport: boolean;
  reportTitle: string;
};

const RlCloudSandboxDroppedFiles: React.FC<RlCloudSandboxDroppedFilesProps> = ({
  analysisId,
  droppedFiles,
  isMergedReport,
  isStoredReport,
  isPrivate,
  isNetworkReport,
  reportTitle
}) => {
  const hasDroppedFiles = Boolean(droppedFiles?.length);

  return (
    <>
      <Title headingLevel="h2" title={`Dropped Files (${reportTitle})`}>
        <RenderWhen condition={hasDroppedFiles}>
          <div className="flex flex-gap-2">
            <DroppedFilesStaticAnalysisButton
              analysisId={analysisId}
              isMergedReport={isMergedReport}
              isStoredReport={isStoredReport}
              isPrivate={isPrivate}
              isNetworkReport={isNetworkReport}
            />
            <DownloadDroppedFilesButton
              analysisId={analysisId}
              isMergedReport={isMergedReport}
              isStoredReport={isStoredReport}
              isNetworkReport={isNetworkReport}
            />
          </div>
        </RenderWhen>
      </Title>
      {hasDroppedFiles ? (
        <RlCloudSandboxDroppedFilesGrid droppedFiles={droppedFiles} />
      ) : (
        <b>{DYNAMIC_ANALYSIS_EMPTY_MESSAGES.dropped_files}</b>
      )}
    </>
  );
};

export default RlCloudSandboxDroppedFiles;
